var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 35,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.933 7.017c1.133-4.902 8.514-4.902 9.633 0 .666 2.875-1.162 5.312-2.748 6.828-1.162 1.105-2.99 1.09-4.151 0-1.573-1.516-3.4-3.953-2.734-6.828zM21.35 24.017c1.133-4.902 8.556-4.902 9.69 0 .666 2.875-1.162 5.312-2.763 6.828-1.162 1.105-3.003 1.09-4.165 0-1.6-1.516-3.428-3.953-2.762-6.828z",
    stroke: "#DD0510",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 7.583h3.797c2.62 0 3.84 3.244 1.87 4.973l-11.32 9.902c-1.968 1.714-.75 4.959 1.857 4.959H17",
    stroke: "#DD0510",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.772 8.292h.017M26.19 25.292h.016",
    stroke: "#DD0510",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrip);
export default __webpack_public_path__ + "static/media/trip.ad77acf9760ded45171d8b3d92368aa8.svg";
export { ForwardRef as ReactComponent };